import { render, staticRenderFns } from "./SgkMossipHacizForm.vue?vue&type=template&id=ef6ca5ee"
import script from "./SgkMossipHacizForm.vue?vue&type=script&lang=ts"
export * from "./SgkMossipHacizForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports